import React, { useState } from 'react';

import DomainLinkingIPs from '../../components/domainLinkingIPs.js'
import WebsiteSecondaryPageTitle from '../../components/websiteSecondaryPageTitle.js'

import {LinkingIPAddressesPageResult} from '../../../../server/routes/website.js'

interface WebsiteBacklinksWebsitesPageProps {
    server: string,
    pageData: unknown
}
export default function WebsiteBacklinksIPAddresses({ server, pageData }: WebsiteBacklinksWebsitesPageProps) {

	let [data, setData] = useState(pageData as LinkingIPAddressesPageResult);

    return (<>
        <WebsiteSecondaryPageTitle domainPageHeader={data.DomainPageHeader}/>
        <section className="section section-sm">
            <div className="container">
                <DomainLinkingIPs 
                    ipAddresses={data.IPAddresses}
                />    
            </div>
        </section>
    </>)
}

